<template>
    <div class="bg-grey vh-100">
        
        <!-- HEADER -->
        <div class="header-top bg-white">
            <div class="header-top--inner w-limit d-flex justify-content-between align-items-center">
                <div class="header-top--left">
                    <div class="header-item">
                        <img src="../../assets/icons/back-blue.svg" alt="a" @click="dashboard">
                    </div>
                </div>
                <div class="header-top--middle f-cont f-16 f-bold">Penggajian & Komisi</div>
                <div class="header-top--right">
                    <div class="header-item"></div>
                </div>
            </div>
        </div>

        <!-- CONTENT -->
        <div class="content-wrapper main-page has-bottom-menu">

            <div class="section-penggajian m-t-16 w-limit">
                <div class="f-16 f-c-midgrey p-x-20">Penggajian</div>    
                <div class="section-group-line m-t-12 bg-white">
                    <div class="section-item" v-if="validateAccess('payroll.create')" @click="gofakturgaji">
                        <div class="f-16 f-semi">Bayar Gaji</div>
                        <img src="../../assets/icons/chevron-right1.svg" alt="a">
                    </div>
                    <div class="section-item" v-if="validateAccess('payroll.payrollHistory')" @click="gohistorygaji">
                        <div class="f-16 f-semi">Riwayat Pembayaran Gaji</div>
                        <img src="../../assets/icons/chevron-right1.svg" alt="a">
                    </div>
                </div>
            </div>

            <div class="section-komisi m-t-24 w-limit">
                <div class="f-16 f-c-midgrey p-x-20">Komisi & Tanggungan</div>
                <div class="section-group-line m-t-12 bg-white">
                    <div class="section-item" v-if="validateAccess('payroll.payrollSalesCommision')" @click="gokomisi">
                        <div class="f-16 f-semi">Komisi Sales</div>
                        <img src="../../assets/icons/chevron-right1.svg" alt="a">
                    </div>
                    <div class="section-item" v-if="validateAccess('payroll.cashReceipt')" @click="gokasbon">
                        <div class="f-16 f-semi">Kasbon Karyawan</div>
                        <img src="../../assets/icons/chevron-right1.svg" alt="a">
                    </div>
                    <div class="section-item" v-if="validateAccess('payroll.fine')" @click="gopotongan">
                        <div class="f-16 f-semi">Denda Karyawan</div>
                        <img src="../../assets/icons/chevron-right1.svg" alt="a">
                    </div>
                </div>
            </div>

        </div>

        <!-- MENUBAR BOTTOM -->


    </div>

</template>

<script>
    export default {
        name: "Penggajian",
        methods:{
            setMenu() {
                // const navheight = "198px";
                // const navout = $('.nav-bottom--inner').outerHeight();
                // const navin = $('li.navbar-item.home').outerHeight();
                // $(".nav-bottom--inner").css("transform", "translateY(" + (navout - navin) + "px)");
                // $(".nav-bottom--inner").css("transform", "translateY(" + navheight + ")");
            },

            dashboard(){
                this.$router.push('/dashboard')
            },
            karyawan(){
                this.$router.push('/karyawan')
            },

            outlet(){
                this.$router.push('/addoutlet')
            },

            menu(){
                this.$router.push('/detailakunowner')
            },

            toggleMenu() {
                $("#nav-bottom").toggleClass("is-open");
            },

            gokomisi(){
                this.smartTrackingClick("list_komisi");
                this.$emit('listkomisi');
            },

            gopotongan(){
                this.smartTrackingClick("list_denda");
                this.$emit('listpotongan');
            },

            gokasbon(){
                this.smartTrackingClick("list_kasbon");
                this.$emit('listkasbon');
            },

            gofakturgaji(){
                this.smartTrackingClick("bayar_gaji");

                this.$emit('showfakturgaji');
            },
            gohistorygaji(){
                this.smartTrackingClick("list_bayar_gaji");
                this.$emit('showhistory');
            },

        },
        mounted() {
            $('#loadingPage').hide()
        },

    }

    // alert($(".nav-bottom--inner").outerHeight())

</script>
